<template>
  <div id="app">
    <!-- MOBILE VIEW -->
    <template v-if="isMobile()">
      <!-- SideNav -->
      <app-side-nav @alertMsg="alertMsg"/>

      <!-- DIALOG -->
      <v-dialog/>

      <router-view class="main"></router-view>

      <template v-if="alertMsgs">
          <Alert
              :type="alertMsgs.type"
              :key="alertMsgs.key"
              class="side-alert"
          >
              {{ alertMsgs.message }}
          </Alert>
      </template>
    </template>

    <!-- WEB VIEW -->
    <div class="web-view" v-else>
      <h5>در حالت جاری امکان دسترسی برای شما فراهم نمی‌باشد.</h5>
      <h6>برای استفاده از وب‌اَپ از گوشی همراه یا تبلت استفاده فرمایید.</h6>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import AppSideNav from '@/components/SideNav.vue';

export default {
    name: 'app',
    components: {
        Alert,
        AppSideNav
    },
    data() {
        return {
            alertMsgs: undefined
        }
    },
    watch: {
        '$route'() {
            this.alertMsgs = undefined;
        }
    },
    mounted() {
      // this.firstVisit();
    },
    methods: {
        alertMsg(msg) {
            this.alertMsgs = msg;
        },

        // Detects if user has mobile browser or not.
        firstVisit() {
            // the user agent string for the current browse
            let userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            
            if(userAgent && !localStorage.getItem('pwa_alert')) {
                this.$modal.show('dialog', {
                    title: 'اطلاعیه!',
                    text: 'با استفاده از گزینه Add to Home screen بر روی مرورگر خود شما می‌توانید از نسخه‌ی PWA ما بر روی گوشی خود استفاده نمایید.',
                    buttons: [
                        {
                            title: 'بستن',
                            default: true,
                            handler: () => { 
                                this.$modal.hide('dialog');
                            }
                        }
                    ]
                });

                localStorage.setItem('pwa_alert', 'showed');
            }
        },

        // detects if user has mobile browser or not.
        isMobile() {
            // first get the size from the window
            // if that didn't work, get it from the body
            // let width = (window.innerWidth || document.body.clientWidth) < 768;

            // the user agent string for the current browse
            let userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            
            // return (width || userAgent) ? true : false;
            return userAgent ? true : false;
        }
    }
}
</script>

<style src="@/assets/styles/App.css"></style>
<style src="@/assets/fonts/_fonts.css"></style>
<style>
.web-view {
  display: flex;
  flex-direction: column;

  min-height: 100vh;
}
.web-view h5, 
.web-view h6 {
  margin: auto;
}
.web-view h5 {
  margin-bottom: 10pt;
}
.web-view h6 {
  margin-top: 10pt;
}
.side-alert {
  top: unset !important;
  right: unset !important;
  bottom: 12pt;
  left: 6pt;
  
  z-index: 1035;
}
.v--modal {
  text-align: right !important;
  left: none;
  right: 50%;
}
/* .v--modal ~ .lrg-modal .v--modal{ */
.vue-dialog {
  width: 200pt !important;
  margin-right: -100pt;
}
.lrg-modal .v--modal{
  width: 95% !important;
  margin-right: -47.5%;
}
.v--modal-overlay {
    z-index: 9999 !important;
}
@media (max-width: 768px) { 
  .popup-win {
    padding-left: 100% !important;
  }
  .v--modal-overlay .v--modal-box {
    width: 100vw !important;
  }
  .v--modal-overlay .vue-dialog {
    width: 200pt !important
  }
}
</style>
